import React from "react";
import { callNumber, openExternalUrl, openMailTo } from "../external_link";
import { AgencyId } from "../messages";
import { STRINGS } from "../strings";
import { Agency } from "../system/AppState/AppAgenciesState";
import { AppCaregiver } from "../system/AppState/AppCaregiverState";
import { translate } from "../translate";
import { getMedFlytLog } from "../utils/DeviceUtils";
import { HashMap } from "../utils/HashMap";
import { FACEBOOK_ICON, WHATSAPP_ICON } from "../utils/svg_social";
import { CALL_SUPPORT_ICON, ENVELOPE_CLOSED_ICON, MESSAGE_ICON } from "../utils/svgs_new";
import { AppIcon } from "./Generic/AppIcon";
import { AppList, AppListItem } from "./Generic/AppList";

interface Props {
  caregiver: AppCaregiver;
  agencies: HashMap<AgencyId, Agency>;
  getAnomalies: (noEncode: boolean) => Promise<string>;
  onClickChatSupport: () => void;
}

const ContactSupportList = (props: Props) => {
  const handleSendMailClick = React.useCallback(async () => {
    const email = "info@medflyt.com";
    const subject = "MedFlyt Support";
    const anomalies = await props.getAnomalies.call(null, true);
    const body = getMedFlytLog(props.caregiver, props.agencies.values(), anomalies);

    openMailTo(email, subject, body);
  }, [props.agencies, props.caregiver, props.getAnomalies]);

  const handleClickChatOnWhatsApp = React.useCallback(() => {
    openExternalUrl("https://wa.me/17185502775");
  }, []);

  const handleClickChatOnFacebook = React.useCallback(() => {
    openExternalUrl("https://m.me/medflyt");
  }, []);

  const handleClickCallNumber = React.useCallback(() => callNumber("+17185502775"), []);

  return (
    <AppList bordered={true}>
      <AppListItem
        leading={<AppIcon icon={WHATSAPP_ICON} size={24} />}
        title={translate(STRINGS.CONNECT_WITH_US_ON_WHATSAPP)}
        onClick={handleClickChatOnWhatsApp}
      />
      <AppListItem
        leading={<AppIcon icon={FACEBOOK_ICON} size={24} />}
        title={translate(STRINGS.CONNECT_WITH_US_ON_FACEBOOK)}
        onClick={handleClickChatOnFacebook}
      />
      <AppListItem
        leading={<AppIcon icon={ENVELOPE_CLOSED_ICON} size={24} />}
        title={translate(STRINGS.SEND_US_A_MAIL)}
        onClick={handleSendMailClick}
      />
      <AppListItem
        leading={<AppIcon icon={MESSAGE_ICON} size={24} />}
        title={translate(STRINGS.LIVE_CHAT_SUPPORT)}
        onClick={props.onClickChatSupport}
      />
      <AppListItem
        leading={<AppIcon icon={CALL_SUPPORT_ICON} size={24} />}
        title={translate(STRINGS.PHONE_CALL_SUPPORT)}
        onClick={handleClickCallNumber}
      />
    </AppList>
  );
};

export default ContactSupportList;
